"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.custom = exports.save = exports.fetchOne = exports.fetch = void 0;
const lodash_1 = require("lodash");
const query_string_1 = require("query-string");
const Api = require("../../Api");
const actions = require("./actions");
const fetch = (dispatch) => {
    return async (workspaceId, objectType, searchQuery = {}) => {
        dispatch(actions.fetchRequest(objectType));
        if (!searchQuery.query) {
            delete searchQuery.query;
        }
        if (!searchQuery.page) {
            delete searchQuery.page;
        }
        if (!searchQuery.size) {
            delete searchQuery.size;
        }
        if (!searchQuery.sort) {
            delete searchQuery.sort;
        }
        if (!searchQuery.filters) {
            delete searchQuery.sort;
        }
        try {
            const { data } = await Api.client.get(`${objectType}?${query_string_1.stringify(Object.assign({}, searchQuery), { arrayFormat: 'bracket-separator' })}`);
            const arrayKey = Object.keys(data).find((v) => !v.startsWith('_'));
            if (!arrayKey) {
                console.warn(`API response does not have a valid root object`);
            }
            dispatch(actions.fetchSuccess(objectType, workspaceId, data[arrayKey], data._metadata));
        }
        catch (error) {
            dispatch(actions.fetchFailure(objectType, Api.extractErrorMessage(error)));
            return false;
        }
        return true;
    };
};
exports.fetch = fetch;
const fetchOne = (dispatch) => {
    return async (workspaceId, objectType, objectId) => {
        dispatch(actions.fetchOneRequest(objectType, objectId));
        try {
            const { data } = await Api.client.get(`${objectType}/${objectId}`);
            const arrayKey = Object.keys(data).find((v) => !v.startsWith('_'));
            if (!arrayKey) {
                console.warn(`API response does not have a valid root object`);
            }
            dispatch(actions.fetchOneSuccess(objectType, objectId, workspaceId, data[arrayKey]));
        }
        catch (error) {
            dispatch(actions.fetchOneFailure(objectType, objectId, Api.extractErrorMessage(error)));
            return false;
        }
        return true;
    };
};
exports.fetchOne = fetchOne;
const save = (dispatch) => {
    return async (workspaceId, objectType, item, itemId, newIdCallback) => {
        dispatch(actions.saveRequest(objectType, itemId || '_'));
        try {
            if (itemId) {
                const { data } = await Api.client.put(`${objectType}/${itemId}`, { item });
                const arrayKey = lodash_1.last(Object.keys(data));
                if (!data[arrayKey]) {
                    console.warn(`API response does not have a "${arrayKey}" root object`);
                }
                dispatch(actions.saveSuccess(objectType, itemId, workspaceId, data[arrayKey]));
            }
            else {
                const { data } = await Api.client.post(`${objectType}`, { item });
                const arrayKey = lodash_1.last(Object.keys(data));
                if (!data[arrayKey]) {
                    console.warn(`API response does not have a "${arrayKey}" root object`);
                }
                dispatch(actions.saveSuccess(objectType, '_', workspaceId, data[arrayKey]));
                // eslint-disable-next-line no-unused-expressions
                newIdCallback && newIdCallback(data[arrayKey].id);
            }
        }
        catch (error) {
            dispatch(actions.saveFailure(objectType, itemId || '_', Api.extractErrorMessage(error)));
            return false;
        }
        return true;
    };
};
exports.save = save;
const custom = (dispatch) => {
    return async ({ workspaceId, request, statePath, reducers }) => {
        dispatch(actions.customRequest(statePath));
        try {
            const { data } = await Api.client.request(request);
            dispatch(actions.customSuccess(statePath, workspaceId, data, reducers));
            return data;
        }
        catch (error) {
            dispatch(actions.customFailure(statePath, Api.extractErrorMessage(error)));
            return;
        }
    };
};
exports.custom = custom;
//# sourceMappingURL=operations.js.map